<!-- 创建时间2023/06/16 16:16:25 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：展示模式 -->
<template>
  <div>
    <div class="yxtbiz-flex-center">
      <yxt-radio v-model="type" class="mr8" :label="0" :disabled="disabled">
        {{ $t('pc_kng_doc_support_html_lbl_picture'/** 图片模式 */) }}
      </yxt-radio>
      <yxt-button type="text" @click="view(0)">{{ $t('pc_kng_doc_support_html_lbl_demo'/** 查看示例 */) }}</yxt-button>
    </div>
    <div class="ml24" v-if="type === 0 && showSize">
      <div class="color-gray-7">
        {{ $t('pc_kng_lbl_fontsizetips'/** 将文档转码为图片进行展示，为保证转码后文字的清晰度，请先确认原始文档字号大小 */) }}
        <yxt-button type="text" @click="view(2)">{{ $t('pc_kng_lbl_fontsizerefer'/** 字号对比图 */) }}</yxt-button>
      </div>
      <yxt-radio-group v-model="size_" direction="row">
        <yxt-radio :label="0">{{ $t('pc_kng_lbl_editfontsizenormal') }}<span class="color-gray-7">{{ $t('pc_kng_lbl_editfontsizenormalcontent') }}</span></yxt-radio>
        <yxt-radio :label="1">{{ $t('pc_kng_lbl_editfontsizesmall') }}<span class="color-gray-7">{{ $t('pc_kng_lbl_editfontsizesmallcontent') }}</span></yxt-radio>
        <yxt-radio :label="2">{{ $t('pc_kng_lbl_editfontsizemini') }}<span class="color-gray-7">{{ $t('pc_kng_lbl_editfontsizeminicontent') }}</span></yxt-radio>
        <yxt-radio v-if="showSizeLimit" :label="3">{{ $t('pc_kng_lbl_editfontsizelimit'/** 极限字体：以上字号都不清晰，选我 */) }}</yxt-radio>
      </yxt-radio-group>
    </div>
    <div class="yxtbiz-flex-center mt10">
      <yxt-radio v-model="type" class="mr8" :label="1" :disabled="disabled">
        {{ $t('pc_kng_doc_support_html_lbl_html'/** HTML模式（以Office文档形式展示，支持复制、搜索） */) }}
      </yxt-radio>
      <yxt-button type="text" @click="view(1)">{{ $t('pc_kng_doc_support_html_lbl_demo'/** 查看示例 */) }}</yxt-button>
    </div>
    <yxtbiz-image-viewer
      v-if="url"
      ref="viewer"
      no-list
      :showNavbar="false"
      :showToolbar="false"
      :data="[{ url }]"
    />
  </div>
</template>

<script>
import { isZhOrHa } from '../../../utils';
export default {
  name: 'form-display-mode',
  props: {
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: undefined
    },
    showSize: {
      type: Boolean,
      default: false
    },
    showSizeLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: ''
    };
  },
  computed: {
    type: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    size_: {
      get() {
        return this.size;
      },
      set(val) {
        this.$emit('update:size', val);
      }
    }
  },
  created() {
    if (this.size === undefined) this.size_ = 0;
  },
  methods: {
    view(type) {
      const imgUrls = {
        0: isZhOrHa ? 'ufd/407a24/kng/pc/img/mode-picture1.png' : 'ufd/d8a55a/kng/pc/img/mode-picture1_en.png',
        1: isZhOrHa ? 'ufd/407a24/kng/pc/img/mode-html1.png' : 'ufd/d8a55a/kng/pc/img/mode-html1_en.png',
        2: isZhOrHa ? 'ufd/55a3e0/kng/pc/img/fontsize.png' : 'ufd/d8a55a/kng/pc/img/fontsize_en2.png'
      };
      this.url = this.$staticBaseUrl + imgUrls[type];
      this.$nextTick(() => {
        this.$refs.viewer && this.$refs.viewer.view(0);
      });
    }
  }
};
</script>